module.exports = __webpack_public_path__ + "img/Icon_StrongTeam.49d70741.png";